import { Box, Tab, Tabs } from '@mui/material'
import React, { useState } from 'react'
import StChart from '../StockChart';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import E from '../../pages/Dashboard.module.css'
import StChart2 from '../StockChart2';
import { useSelector } from 'react-redux';

const TabChart = ({chart,day30,hour8,hours720,label}) => {
  const {duration}=useSelector(state=>state.p.time)

    const [value,setValue]=useState("1")
    const handleChange = (event, newValue) => {
        setValue(newValue);
      };
  return (
    <div>
      <TabContext value={value}>
  <Box  style={{direction:'rtl',marginBottom:'-40px',marginRight:'10px',padding:'0px 8px'}}>
    <TabList variant="scrollable" scrollButtons="auto" onChange={handleChange} aria-label="lab API tabs example">
      <Tab label="24 ساعت گذشته" value="1" />
      <Tab label={`${duration} روز گذشته (روزانه)`} value="2" />
      <Tab label={`${duration} روز گذشته (8 ساعته)`} value="3" />
      <Tab label={`${duration} روز گذشته (1 ساعته)`}value="4" />
    </TabList>
  </Box>
  <TabPanel value="1" style={{padding:'25px 0px'}}>
  <div style={{direction:'ltr'}}>
    <div className={E.StChartCon}>
            <h2 style={{margin:'4px auto'}}>وضعیت 24 ساعت گذشته {label} 
</h2>
            <StChart stats={chart&&chart} flag={0}/></div>
            <div className={E.StChartCon}>
            <h2 style={{margin:'4px auto'}}> وضعیت 24 ساعت گذشته {label}
</h2>
            <StChart2 stats={chart&&chart} flag={0}/></div>
            
      </div>
  </TabPanel>
  <TabPanel value="2" style={{padding:'25px 0px'}}>
  <div style={{direction:'ltr'}}>
    <div className={E.StChartCon}>
            <h2 style={{margin:'4px auto'}}> وضعیت  {duration} روز گذشته {label}
</h2>
            <StChart stats={day30&&day30} flag={0}/></div>
            <div className={E.StChartCon}>
            <h2 style={{margin:'4px auto'}}> وضعیت {duration} روز گذشته {label}
</h2>
            <StChart2 stats={day30&&day30} flag={0}/></div>
            
      </div>
  </TabPanel>
  <TabPanel value="3" style={{padding:'25px 0px'}}>
  <div style={{direction:'ltr'}}>
    <div className={E.StChartCon}>
            <h2 style={{margin:'4px auto'}}>    وضعیت {duration} روز گذشته  {label} (8ساعته)  
</h2>
            <StChart stats={hour8&&hour8} /></div>
            <div className={E.StChartCon}>
            <h2 style={{margin:'4px auto'}}> وضعیت {duration} روز گذشته  {label} (8ساعته) 
</h2>
            <StChart2 stats={hour8&&hour8} /></div>
            
      </div>
  </TabPanel>
  <TabPanel value="4" style={{padding:'25px 0px'}}>
  <div style={{direction:'ltr'}}>
    <div className={E.StChartCon}>
            <h2 style={{margin:'4px auto'}}> وضعیت {duration} روز گذشته {label} (1 ساعته)
</h2>
            <StChart stats={hours720&&hours720} /></div>
            <div className={E.StChartCon}>
            <h2 style={{margin:'4px auto'}}>   وضعیت {duration} روز گذشته  {label} (1 ساعته)
</h2> 
            <StChart2 stats={hours720&&hours720} /></div>
            
      </div>
  </TabPanel>
</TabContext>
    </div>
  )
}

export default TabChart
